<template>
  <ion-page>
    <master-layout pageTitle="لیست خودروهای مشتری">
      <ion-card>
        <ion-card-content>
          <div class="top_items">
            <div class="h5">خودروهای مشتریان
            </div>
          </div>

          <DataTable :headers="headers" route="customerCarReport/ListAjax"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      customer : null,
      headers:[
        'تیپ خودرو',
        'نام مشتری',
        'آخرین مراجعه',
        'کیلومتر فعلی',
      ]
    };
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  },
};
</script>

<style scoped>
.top_items
{
  display: flex;
  justify-content: space-between;
}
.h5 {
  font-weight: 900;
  font-size: 15px;
  align-self: center;
  color: #000000b3;
}
</style>